export var aopOrderBookClientFilter = function (data) {
    var aopOrderBookEntity = {
        aopOrderBookClientList: [],
    };
    if (!!data && data !== "") {
        var orderBookList = JSON.parse(data);
        aopOrderBookEntity.aopOrderBookClientList = orderBookList.map(function (recordCode) {
            return recordCode;
        });
    }
    return aopOrderBookEntity;
};
